import { render, staticRenderFns } from "./_taskControls.vue?vue&type=template&id=02dfd526"
import script from "./_taskControls.vue?vue&type=script&lang=js"
export * from "./_taskControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports